"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default() {
  return window && window.navigator.userAgent.indexOf('Trident/') > 0;
};
exports["default"] = _default;